import React, { useEffect } from 'react'
import PageLoader from 'shared/components/PageLoader'
import { useAuth } from './shared/hooks/useAuth'
import { cleanup } from 'shared/utils/noapp/auth'

const Cleanup: React.FC = () => {
  const authContext = useAuth()

  useEffect(() => {
    cleanup()
    authContext.userManager.clearStaleState()
  })

  return <PageLoader />
}

export default Cleanup
